import { PublicClientApplication, BrowserAuthError } from '@azure/msal-browser';
import { msalConfig } from '../authConfig';

/**
 * Singleton MSAL instance
 * This ensures we only have one MSAL instance across the entire application
 */
let msalInstance: PublicClientApplication | null = null;
let initializationPromise: Promise<void> | null = null;

export function getMsalInstance(): PublicClientApplication {
  if (!msalInstance) {
    msalInstance = new PublicClientApplication(msalConfig);

    // Processa resposta de redirect pendente na inicializacao
    initializationPromise = msalInstance.initialize().then(() => {
      return msalInstance!.handleRedirectPromise().then((response) => {
        if (response) {
          console.log('[MSAL] Redirect response processed successfully');
        }
      }).catch((error) => {
        console.error('[MSAL] Error handling redirect:', error);
        // Limpa cache se houver erro de hash (comum apos inatividade)
        if (error instanceof BrowserAuthError && error.errorCode === 'hash_empty_error') {
          console.warn('[MSAL] Hash empty error detected, clearing cache');
          msalInstance!.clearCache();
        }
      });
    });
  }
  return msalInstance;
}

export function getMsalInitializationPromise(): Promise<void> | null {
  return initializationPromise;
}
